import React from 'react';
import { getGatewayIcon } from 'utils/paymentFormatters.jsx';

export const GatewaySelection = ({ gateways, isLoading, onSelectGateway }) => {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-10">
        <div className="text-sm text-gray-500 dark:text-gray-400">
          Loading payment gateways...
        </div>
      </div>
    );
  }

  if (gateways.length === 0) {
    return (
      <div className="flex items-center justify-center py-10">
        <div className="text-sm text-gray-500 dark:text-gray-400">
          No payment gateways available
        </div>
      </div>
    );
  }

  return (
    <>
      <p className="mb-4 text-sm text-gray-600 dark:text-gray-400">
        Select a payment gateway to create a payment link.
      </p>
      <div className="space-y-3">
        {gateways.map((gateway) => (
          <button
            key={gateway.GatewayId}
            onClick={() => onSelectGateway(gateway)}
            className="group w-full rounded-xl border border-gray-200 bg-white/70 p-4 text-left shadow-sm transition-all hover:-translate-y-0.5 hover:border-primary-200 hover:shadow-md dark:border-gray-700 dark:bg-gray-800/70 dark:hover:border-primary-700/40"
          >
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
              <div className="space-y-1">
                <div className="flex items-center gap-2">
                  <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-primary-50 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-white dark:bg-primary-900/30 dark:text-primary-200">
                    {getGatewayIcon(gateway.GatewayName)}
                  </span>
                  <div>
                    <h4 className="text-sm font-semibold text-gray-900 dark:text-gray-100">
                      {gateway.GatewayName}
                    </h4>
                    <p className="text-xs text-gray-500 dark:text-gray-400">
                      {gateway.ApiBaseUrl}
                    </p>
                  </div>
                </div>

                {gateway.ApiVersion && (
                  <p className="text-xs text-gray-500 dark:text-gray-400 sm:ml-12">
                    API Version: {gateway.ApiVersion}
                  </p>
                )}
              </div>

              <div className="flex items-center gap-2">
                <span className="hidden text-xs font-medium text-primary-600 group-hover:inline dark:text-primary-300">
                  Choose
                </span>
              </div>
            </div>
          </button>
        ))}
      </div>
    </>
  );
};
